import {useAllUnitsQuery} from '@transactions/graphql';
import {Plus} from 'lucide-react';
import * as React from 'react';
import {useBreadcrumb} from 'src/Breadcrumbs';
import {Button} from 'src/Button';
import {DashedAddButton} from 'src/DashedAddButton';
import {useModals} from 'src/Modals';
import {UnitCard} from 'src/UnitsView/UnitCard';

export const UnitsView = () => {
  useBreadcrumb({
    label: 'Units',
    fallback: [{label: 'Settings', href: '/settings'}],
  });
  const {data, loading, refetch} = useAllUnitsQuery();
  const {createUnitModal} = useModals();

  const handleRefetch = () => {
    refetch();
  };

  const handleCreate = () => {
    createUnitModal.openModal({onSuccess: handleRefetch});
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <span className="text-muted-foreground">Loading units...</span>
      </div>
    );
  }

  const units = data?.allUnits || [];

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold">Units</h2>
          <p className="text-muted-foreground text-sm">
            Custom currencies for non-monetary wallets — passes, miles, credits
          </p>
        </div>
        <Button
          variant="primary"
          onClick={handleCreate}
          className="hidden sm:inline-flex"
        >
          <Plus className="mr-1 h-4 w-4" />
          Create Unit
        </Button>
      </div>

      {units.length === 0 ? (
        <div className="border-border rounded-lg border border-dashed p-8 text-center">
          <p className="text-muted-foreground mb-4">No units created yet</p>
          <p className="text-muted-foreground mb-4 text-sm">
            Units let a wallet account track things that aren't money — a
            5-pack of tennis classes, airline miles, store credits — with
            amounts rendered in their own words ("3 passes"). Create an
            account denominated in a unit, then record what it cost as a
            conversion transfer.
          </p>
          <Button variant="outline" onClick={handleCreate} type="button">
            Create your first unit
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <DashedAddButton onClick={handleCreate}>Create Unit</DashedAddButton>
          {units.map((unit) => (
            <UnitCard key={unit._id} unit={unit} onUpdate={handleRefetch} />
          ))}
        </div>
      )}
    </div>
  );
};
